// client/src/pages/adminpages/CompletedProjectPage.js
import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import CompletedProjectList from '../../components/admin/project/CompletedProjectList';

function CompletedProjectPage() {
  return (
    <AdminLayout title="완료된 프로젝트 보기">
      <div style={{ height: 'calc(100vh - 240px)', overflow: 'hidden' }}>
        <CompletedProjectList />
      </div>
    </AdminLayout>
  );
}

export default CompletedProjectPage;
